import React from 'react'
import styled from 'styled-components'
import { View, Text } from '@olxbr/design-system'
import medias from '../../../util/medias'

const Base = styled(View)`
  border-radius: 3px 3px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ backgroundColor }) =>
    backgroundColor &&
    `
    background-color: ${backgroundColor};
  `}
  width: 100%;
  height: 0;
  top: -50px;
  transition: top 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
  position: relative;
  ${medias.medium`
    padding: 8px 0px 24px opx;
    margin-top: var(--spacing-4);
  `}

  &.in {
    height: 50px;
    top: 0;
    justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  }
`

const Enclousure = styled.div`
  height: 50px;
`

const WaitLockBanner = props => {
  const { value } = props

  const isPlural = value => (value > 1 ? 's' : '')

  const formatedTime = secondsFull => {
    const hours = Math.floor(secondsFull / 3600)
    const minutes = Math.floor((secondsFull % 3600) / 60)
    const seconds = Math.floor((secondsFull % 3600) % 60)

    const showHours = hours > 0 ? `${hours}h ` : ''
    const showMinutes = minutes > 0 ? `${minutes}min ` : ''
    const showSeconds = hours === 0 && seconds >= 0 ? `${seconds}s` : ''

    return showHours + showMinutes + showSeconds
  }

  return (
    <Base
      className={value >= 0 ? 'in' : ''}
      backgroundColor={props.backgroundColor}
      justifyContent={props.justifyContent}
    >
      <Text weight="fine">
        {' '}
        Você pode tentar novamente em <Text weight="bold">{formatedTime(value)}</Text>
      </Text>
    </Base>
  )
}

WaitLockBanner.defaultProps = {
  value: '...',
  backgroundColor: '#F8F3FD',
}

export default WaitLockBanner
